import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Below this width the supervisor web app switches to its phone layout: a top
 * bar with a slide-out menu instead of the icon rail, and pages without the
 * desktop width floor. Matches MUI's default `md` breakpoint.
 */
export const MOBILE_LAYOUT_MAX_WIDTH = 899.95;

export const MOBILE_LAYOUT_QUERY = `(max-width: ${MOBILE_LAYOUT_MAX_WIDTH}px)`;

const useIsMobileLayout = (): boolean =>
	useMediaQuery(MOBILE_LAYOUT_QUERY, { noSsr: true });

export default useIsMobileLayout;
